module.exports = __webpack_public_path__ + "fonts/NetflixSansLight.9cf39d19.ttf";